import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  headerContainer: {
    marginTop: 36,
  },
  billTo: {
    marginTop: 20,
    paddingBottom: 3,
    fontFamily: "Helvetica-Oblique",
  },
});

const DetailPdfTo = ({ detail }) => (
  <View style={styles.headerContainer}>
    <Text style={styles.billTo}>Detail To:</Text>
    <Text>Client: {detail.nmCorporate}</Text>
    <Text>Employee: {detail.nmEmployee}</Text>
    <Text>Project: {detail.nmProject}</Text>
  </View>
);

export default DetailPdfTo;
